import { render, staticRenderFns } from "./PartnersContract.vue?vue&type=template&id=cad2bd8c&scoped=true&"
import script from "./PartnersContract.vue?vue&type=script&lang=ts&"
export * from "./PartnersContract.vue?vue&type=script&lang=ts&"
import style0 from "./PartnersContract.vue?vue&type=style&index=0&id=cad2bd8c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad2bd8c",
  null
  
)

export default component.exports